import parentApi from './axios/studentAxios';
export const parentRegisterRequest = (data) => parentApi.post('/parents/register', data);

export const parentLoginRequest = (data) => parentApi.post('/auth/login', data);

export const parentRefreshTokenRequest = (refreshToken) =>
  parentApi.post('/auth/refresh', { refresh_token: refreshToken });

export const parentLogoutRequest = (data) => parentApi.post('/auth/logout', data);
